<script setup lang="ts">
import type { BaseItem } from '~/models/Content/BaseItem'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useUrlBuilder } from '~/composables/useUrlBuilder'
import { useContentHelper } from '~/composables/useContentHelper'
import LinkOrAnchor from '~/components/utils/LinkOrAnchor.vue'

const props = defineProps<{ resource: BaseItem, isAnchor?: boolean }>()

const { getTitle } = useContentHelper()
const { buildResourceUrl } = useUrlBuilder()
const { t } = useI18n()

const title = computed(() => getTitle(props.resource))
const link = computed(() => buildResourceUrl(props.resource))
</script>

<template>
  <aside
    v-if="resource.new"
    class="bg-green-40 pointer-events-none absolute top-0 right-0 z-20 rounded-bl-2xl p-1.5 pl-2 text-sm font-medium tracking-wider text-white uppercase"
    v-text="t('newShort')"
  />
  <LinkOrAnchor
    :link="link"
    class="flex h-full w-full items-center border border-(--card-border) bg-(--card-bg) p-6 text-xl font-bold text-(--card-text) transition duration-100 ring-inset hover:bg-white hover:ring hover:ring-(--card-border) focus-visible:ring"
    :is-anchor="props.isAnchor"
  >
    {{ title }}
  </LinkOrAnchor>
</template>
